import { Component } from '@angular/core';

@Component({
  selector: 'app-cards2-examples-10',
  templateUrl: './cards2-examples-10.component.html'
})
export class Cards2Examples10Component {}
